import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

export const Wrapper = styled.div`
    display: grid;
    overflow: scroll;

    max-width: 100vw;
    max-height: 100vh;
    align-items: center;

    grid-auto-flow: column;
    grid-column-gap: 3vw;
    grid-auto-columns: 25vw;
    padding: 2vh 3vw;
    margin-bottom: -2vh;

    &::-webkit-scrollbar {
        display: none;
    }

    @media only screen and (orientation: landscape) {
        grid-auto-flow: row;
        grid-row-gap: 2vh;
        padding: 0;
        padding-top: 3vh;
        grid-auto-rows: min-content;
        grid-auto-columns: unset;
        justify-content: stretch;
    }
`

export const TeacherParticipantView = styled.div`
    ${FlexCentered}
    flex-direction: column;
    position: relative;
    align-self: center;

    @media only screen and (orientation: landscape) {
        justify-self: center;
    }
`

export const ArtefactMinimized = styled.div`
    min-height: 70%;
    min-width: 80px;
    background-color: #e5e5e5;
    color: #222;
    font-size: 50px;
    font-weight: bold;
    text-align: center;
    aspect-ratio: 1/1;
    ${FlexCentered}
    justify-self: center;
    align-self: center;
    border-radius: 20px;
    background-image: url('/assets/menu-icon.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 60%;
    @media only screen and (orientation: landscape) {
        margin: 0 2vh;
        height: 12vh;
        min-height: 80px;
    }
`
